import { environment } from 'src/environments/environment';
import { TYPE_TRANSACTION } from './global.constant';

export const BANK_ENTITIES_TABLE_COLUMNS = [
  {
    name: 'financial.bankEntities.id',
    prop: 'bankId',
    width: 50,
  },
  {
    name: 'financial.bankEntities.name',
    prop: 'name',
    width: 100,
  },
  {
    name: 'words.currency',
    prop: 'currencyId.code',
    width: 50,
  },
  {
    name: 'financial.bankEntities.registeredBy',
    prop: 'registeredBy.username',
    width: 50,
  },
];

export const BANKS_COLUMNS_BY_HOLDERS = [
  {
    name: 'financial.holders.fullName',
    prop: 'fullName',
  },
  {
    name: 'financial.holders.documentNumber',
    prop: 'documentNumber',
  },
  {
    name: 'financial.holders.accountNumber',
    prop: 'accountNumber',
  },
  {
    name: 'financial.holders.accountType',
    prop: 'accountType',
  },
  {
    name: 'financial.holders.bankName',
    prop: 'bankName',
  },
  {
    name: 'financial.holders.currencyCode',
    prop: 'currencyCode',
    width: 100,
  },
  {
    name: 'financial.holders.registeredFrom',
    prop: 'registeredFrom',
    width: 150,
  },
  {
    name: 'financial.holders.registeredBy',
    prop: 'registeredBy',
  },
  {
    name: 'words.createdAt',
    prop: 'createdAt',
  },
  {
    name: 'financial.holders.registeredByUsername',
    prop: 'registeredByUsername',
  },
  {
    name: 'financial.holders.bankCreatedAt',
    prop: 'bankCreatedAt',
  },
  {
    name: 'financial.holders.editedBy',
    prop: 'editedBy',
  },
  {
    name: 'financial.holders.updatedAt',
    prop: 'updatedAt',
    width: 250,
  },
];
export const ASIGNATE_TO_OPTIONS = [
  { value: 'To Players', label: 'financial.holders.player' },
  { value: 'To Agents', label: 'financial.holders.agent' },
  { value: 'To Companies', label: 'financial.holders.company' },
];

export const ASSIGNED_TO = {
  COMPANIES: 'To Companies',
  AGENTS: 'To Agents',
  PLAYERS: 'To Players',
} as const;

export const ACCOUNT_TYPE_OPTIONS = [
  { value: 'Ahorro', label: 'financial.holders.savings' },
  { value: 'Corriente', label: 'financial.holders.current' },
];

export const ACCEPTED_QR_IMAGE_TYPES = ['image/png', 'image/jpg', 'image/jpeg', 'image/webp'];

export const MAX_QR_IMAGE_SIZE_BYTES = 2 * 1024 * 1024;

export const TRANSACTIONS_TABLE_COLUMNS = [
  {
    name: 'financial.transactions.table.playerId',
    prop: 'playerId.accountInfo.playerId',
    width: 150,
  },
  {
    name: 'financial.transactions.table.username',
    prop: 'playerId.personalInfo.username',
  },
  {
    name: 'financial.transactions.table.currencyId',
    prop: 'currencyId.code',
    width: 120,
  },
  {
    name: 'financial.transactions.table.userId',
    prop: 'userId.username',
  },
  {
    name: 'financial.transactions.table.cashdesksId',
    prop: 'cashdesksId',
  },
  {
    name: 'financial.transactions.table.cashdesksIdSecondary',
    prop: 'cashdesksIdSecondary',
  },
];

export const TRANSACTIONS_OPERATIONS_TYPES = {
  DEBIT: { es: 'Débito', en: 'Debit' },
  CREDIT: { es: 'Crédito', en: 'Credit' },
};

export const OPTIONS_STATUS_TRASACTION_WITHDRAW = {
  PENDING: { es: 'Pendiente', en: 'Pending' },
  ACCEPTED: { es: 'Aceptada', en: 'Accepted' },
  PROCESSED: { es: 'Procesada', en: 'Processed' },
  REJECTED: { es: 'Rechazada', en: 'Rejected' },
};

export const DEPOSIT_AMOUNT_LIMITS = {
  MIN: 5,
  MAX: 1000,
} as const;

export const BANK_HOLDER_COUNTDOWN_SECONDS = 1800;

export const DEPOSIT_SEARCHING_MESSAGE_KEYS = [
  'requests.deposit.searching.step1',
  'requests.deposit.searching.step2',
  'requests.deposit.searching.step3',
  'requests.deposit.searching.step4',
];

export const DEPOSIT_SEARCHING_MESSAGE_INTERVAL_MS = 2000;

// Built from the deployment's player site so every client sends its own players to its own site.
export const PLAYER_REGISTER_ACCOUNTS_URL = `${environment.siteUrl.replace(/\/$/, '')}/account/withdraw`;

export const OPTIONS_STATUS_TRASACTION_DEPOSIT = {
  PENDING: { es: 'Pendiente', en: 'Pending' },
  ACCEPTED: { es: 'Aceptada', en: 'Accepted' },
  PROCESSED: { es: 'Procesada', en: 'Processed' },
  REJECTED: { es: 'Rechazada', en: 'Rejected' },
};

export const TRANSACTIONS_NG_SELECT_OPERATIONS_TYPES = [
  {
    label: TRANSACTIONS_OPERATIONS_TYPES.DEBIT,
    value: TRANSACTIONS_OPERATIONS_TYPES.DEBIT.en,
  },
  {
    label: TRANSACTIONS_OPERATIONS_TYPES.CREDIT,
    value: TRANSACTIONS_OPERATIONS_TYPES.CREDIT.en,
  },
];

export const TRANSACTIONS_SELECT_OPERATIONS_TYPES_BACKDOOR = [
  {
    label: 'reports.transactions.deposit',
    value: TYPE_TRANSACTION.DEPOSIT,
  },
  {
    label: 'reports.transactions.withdrawal',
    value: TYPE_TRANSACTION.WITHDRAWAL,
  },
  {
    label: 'reports.transactions.correction',
    value: 'Correction',
  },
];

const TRANSACTION_TYPES = {
  CASH: { es: 'Efectivo', en: 'Cash' },
  BET_CREATED: { es: 'Apuesta creada', en: 'Created bet' },
  RESULTED_BET: { es: 'Apuesta resuelta', en: 'Resulted bet' },
  CANCELED_BET: { es: 'Apuesta cancelada', en: 'Canceled bet' },
  MANUAL_PAYMENT_BET: { es: 'Pago manual', en: 'Pago manual' },
  ROLLBACK_BET_SETTLEMENT: {
    es: 'Devolución de apuesta liquidad',
    en: 'Cancellation of settled bet',
  },
  ROLLBACK_BET_CANCEL: {
    es: 'Devolución de apuesta cancelada',
    en: 'Return of canceled bet',
  },
  CASHOUT: {
    es: 'Cashout',
    en: 'Cashout',
  },
  WITHDRAWAL: { es: 'Retiro', en: 'Withdrawal' },
  BONUS_CONVERSION: { es: 'Liberación de bono', en: 'Bonus Release' },
  CORRECTION: { es: 'Corrección', en: 'Correction' },
};

export const TRANSACTIONS_NG_SELECT_TYPES = [
  {
    label: TRANSACTION_TYPES.BET_CREATED,
    value: TRANSACTION_TYPES.BET_CREATED.en,
  },
  {
    label: TRANSACTION_TYPES.RESULTED_BET,
    value: TRANSACTION_TYPES.RESULTED_BET.en,
  },
  {
    label: TRANSACTION_TYPES.CANCELED_BET,
    value: TRANSACTION_TYPES.CANCELED_BET.en,
  },
  {
    label: TRANSACTION_TYPES.MANUAL_PAYMENT_BET,
    value: TRANSACTION_TYPES.MANUAL_PAYMENT_BET.en,
  },
  {
    label: TRANSACTION_TYPES.ROLLBACK_BET_SETTLEMENT,
    value: TRANSACTION_TYPES.ROLLBACK_BET_SETTLEMENT.en,
  },
  {
    label: TRANSACTION_TYPES.ROLLBACK_BET_CANCEL,
    value: TRANSACTION_TYPES.ROLLBACK_BET_CANCEL.en,
  },
  {
    label: TRANSACTION_TYPES.CASH,
    value: TRANSACTION_TYPES.CASH.en,
  },
  {
    label: TRANSACTION_TYPES.CASHOUT,
    value: TRANSACTION_TYPES.CASHOUT.en,
  },
  {
    label: TRANSACTION_TYPES.WITHDRAWAL,
    value: TRANSACTION_TYPES.WITHDRAWAL.en,
  },
  {
    label: TRANSACTION_TYPES.BONUS_CONVERSION,
    value: TRANSACTION_TYPES.BONUS_CONVERSION.en,
  },
  {
    label: TRANSACTION_TYPES.CORRECTION,
    value: TRANSACTION_TYPES.CORRECTION.en,
  },
];

export const TRANSACTION_ORIGINS = {
  FREE_BET: { es: 'Apuesta Gratis', en: 'Free Bet' },
  SPORT_RADAR: { es: 'Apuesta', en: 'Bet' },
  VIRTUALS: { es: 'Apuesta de virtuales', en: 'Virtual bet' },
  CASINO: { es: 'Apuesta de casino', en: 'Casino bet' },
  SPECIAL: { es: 'Apuesta especial', en: 'Special bet' },
  BACKOFFICE: { es: 'Backoffice', en: 'Backoffice' },
  PLAYERS: { es: 'Jugadores', en: 'Players' },
  CENTER: { es: 'Center', en: 'Center' },
};

export const TRANSACTION_ORIGIN_FLAG_CLASSES: Record<string, string> = {
  [TRANSACTION_ORIGINS.PLAYERS.en]: 'sc-flag-ok-strong',
  [TRANSACTION_ORIGINS.CENTER.en]: 'sc-flag-info',
};

export const TRANSACTION_ORIGIN_DEFAULT_FLAG_CLASS = 'sc-flag-neutral';

export const TRANSACTIONS_NG_SELECT_ORIGINS = [
  {
    label: TRANSACTION_ORIGINS.FREE_BET,
    value: TRANSACTION_ORIGINS.FREE_BET.en,
  },
  {
    label: TRANSACTION_ORIGINS.SPORT_RADAR,
    value: TRANSACTION_ORIGINS.SPORT_RADAR.en,
  },
  {
    label: TRANSACTION_ORIGINS.VIRTUALS,
    value: TRANSACTION_ORIGINS.VIRTUALS.en,
  },
  {
    label: TRANSACTION_ORIGINS.CASINO,
    value: TRANSACTION_ORIGINS.CASINO.en,
  },
  {
    label: TRANSACTION_ORIGINS.SPECIAL,
    value: TRANSACTION_ORIGINS.SPECIAL.en,
  },
  {
    label: TRANSACTION_ORIGINS.BACKOFFICE,
    value: TRANSACTION_ORIGINS.BACKOFFICE.en,
  },
  {
    label: TRANSACTION_ORIGINS.PLAYERS,
    value: TRANSACTION_ORIGINS.PLAYERS.en,
  },
  {
    label: TRANSACTION_ORIGINS.CENTER,
    value: TRANSACTION_ORIGINS.CENTER.en,
  },
];

export const BANK_ACCOUNT_MOVEMENT_STATUS = {
  PENDING: { es: 'Pendiente', en: 'Pending' },
  ACCEPTED: { es: 'Aceptada', en: 'Accepted' },
  PROCESSED: { es: 'Procesada', en: 'Processed' },
  REJECTED: { es: 'Rechazada', en: 'Rejected' },
};

export const JOURNEY_METRICS_STATUS = {
  PENDING: { es: 'Pendiente', en: 'Pending' },
  COMPLETED: { es: 'Completado', en: 'Completed' },
};

export const TRANSFER_RECEIPT_KEY = 'receipt';

export const BANK_ACCOUNT_HISTORY_ACTION = {
  ACTIVATED: 'activated',
  DEACTIVATED: 'deactivated',
} as const;

export const BANK_ACCOUNT_HISTORY_FETCH_LIMIT = 1000;

export const BANK_ACCOUNT_HISTORY_PAGE_SIZE = 10;

export const BANK_ACCOUNT_HISTORY_PERIOD = {
  MONTH: 'month',
  QUARTER: 'quarter',
  YEAR: 'year',
  ALL: 'all',
  CUSTOM: 'custom',
} as const;

export type BankAccountHistoryPeriod =
  (typeof BANK_ACCOUNT_HISTORY_PERIOD)[keyof typeof BANK_ACCOUNT_HISTORY_PERIOD];

export const BANK_ACCOUNT_HISTORY_PERIOD_OPTIONS: {
  value: BankAccountHistoryPeriod;
  label: string;
}[] = [
  { value: BANK_ACCOUNT_HISTORY_PERIOD.MONTH, label: 'players.bankInfo.periodThisMonth' },
  { value: BANK_ACCOUNT_HISTORY_PERIOD.QUARTER, label: 'players.bankInfo.periodQuarter' },
  { value: BANK_ACCOUNT_HISTORY_PERIOD.YEAR, label: 'players.bankInfo.periodYear' },
  { value: BANK_ACCOUNT_HISTORY_PERIOD.ALL, label: 'players.bankInfo.periodAll' },
];

export const BANK_ACCOUNT_HISTORY_PERIOD_MONTHS = {
  [BANK_ACCOUNT_HISTORY_PERIOD.QUARTER]: 3,
  [BANK_ACCOUNT_HISTORY_PERIOD.YEAR]: 12,
} as const;

export const BANK_ACCOUNT_HISTORY_ACTION_ALL = 'all' as const;

export type BankAccountHistoryActionFilter =
  | typeof BANK_ACCOUNT_HISTORY_ACTION_ALL
  | (typeof BANK_ACCOUNT_HISTORY_ACTION)[keyof typeof BANK_ACCOUNT_HISTORY_ACTION];

export const BANK_ACCOUNT_HISTORY_ACTIONS = [
  { value: BANK_ACCOUNT_HISTORY_ACTION.ACTIVATED, label: 'players.bankInfo.historyActivated' },
  { value: BANK_ACCOUNT_HISTORY_ACTION.DEACTIVATED, label: 'players.bankInfo.historyDeactivated' },
];

export const BANK_ACCOUNT_STATE = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
} as const;

export enum BankInfoView {
  ACCOUNTS = 'accounts',
  HISTORY = 'history',
}

export const BANK_LOGOS: { keywords: string[]; logo: string }[] = [
  { keywords: ['pichincha'], logo: 'pichincha' },
  { keywords: ['pacifico'], logo: 'pacifico' },
  { keywords: ['guayaquil'], logo: 'guayaquil' },
  { keywords: ['internacional'], logo: 'internacional' },
  { keywords: ['produbanco', 'promerica'], logo: 'produbanco' },
  { keywords: ['jep', 'juventud ecuatoriana progresista'], logo: 'jep' },
];
